import styled from 'styled-components';
export const Container = styled.div `
  display: inline-flex;

  align-items: center;

  margin: 4px;
  padding: var(--space-150) var(--space-250);

  border-radius: var(--radius-brand);

  background: var(--bg-transparent);
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const RemoveButton = styled.button `
  display: flex;

  align-items: center;
  justify-content: center;

  margin-left: var(--space-250);

  color: var(--text-secondary);

  &:hover {
    color: var(--text-primary);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
